import { Box } from "@mui/material";
import UploadStatusAlert from "./UploadStatusAlert";
import DocumentPreview from "./DocumentPreview";
import Thumbnails from "./Thumbnails";

export default function UploadViewerPanel({ selectedFile, uploadStatus }) {
  return (
    <Box flex={1} display="flex" flexDirection="column">
      <UploadStatusAlert status={uploadStatus} />
      <DocumentPreview file={selectedFile} />
      {/* <Thumbnails /> */}
    </Box>
  );
}